/**
 * Copyright 2023-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Dispatch, SetStateAction } from "react";
import { createCtx } from "~/tools";
import type { ResourceGroupData } from "./types";

type Props = {
  resourceGroup?: Partial<ResourceGroupData>;
  setExpression?: Dispatch<SetStateAction<string | undefined>>;
  expression?: string;
};

export const [useResourceGroup, ResourceGroupCtxProvider] = createCtx<Props>();
